var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#4rcmkjii5a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 19.381h-.285c.185-.478.281-.985.285-1.498v-2.997a4.493 4.493 0 0 0-1.318-3.179 4.503 4.503 0 0 0-3.182-1.316h-24a4.503 4.503 0 0 0-3.182 1.316A4.493 4.493 0 0 0 10 14.887v2.996a4.492 4.492 0 0 0 3.33 4.316 4.492 4.492 0 0 0-.33 1.678v2.997c.002.575.114 1.145.33 1.678A4.5 4.5 0 0 0 10 32.868v2.997a4.492 4.492 0 0 0 3.33 4.316 4.492 4.492 0 0 0-.33 1.678v2.997c0 1.192.474 2.335 1.318 3.179A4.503 4.503 0 0 0 17.5 49.35H43c3.978 0 7.794-1.578 10.607-4.389a14.977 14.977 0 0 0 0-21.192A15.008 15.008 0 0 0 43 19.381zm-13.74 8.991H17.5a1.501 1.501 0 0 1-1.5-1.498v-2.997a1.498 1.498 0 0 1 1.5-1.498H34a14.988 14.988 0 0 0-4.74 5.993zM13 14.886a1.498 1.498 0 0 1 1.5-1.498h24a1.501 1.501 0 0 1 1.5 1.498v2.997a1.497 1.497 0 0 1-1.5 1.498h-24a1.5 1.5 0 0 1-1.5-1.498v-2.997zm0 17.982a1.498 1.498 0 0 1 1.5-1.499h13.8a15.12 15.12 0 0 0 0 5.994H14.5a1.501 1.501 0 0 1-1.5-1.498v-2.997zm4.5 13.486a1.501 1.501 0 0 1-1.5-1.498v-2.997a1.498 1.498 0 0 1 1.5-1.499h11.76A14.988 14.988 0 0 0 34 46.354H17.5zm25.5 0c-2.373 0-4.694-.703-6.667-2.02a11.977 11.977 0 0 1-1.819-18.444 12.003 12.003 0 0 1 13.078-2.599 11.997 11.997 0 0 1 5.386 4.415 11.979 11.979 0 0 1-1.493 15.137A12.006 12.006 0 0 1 43 46.354z",
    fill: "url(#m7ybrt618b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 29.87h3a1.501 1.501 0 0 0 1.5-1.498 1.498 1.498 0 0 0-1.5-1.498h-1.5a1.498 1.498 0 0 0-1.5-1.499 1.501 1.501 0 0 0-1.5 1.498v.27a4.5 4.5 0 0 0-2.9 4.987 4.494 4.494 0 0 0 4.4 3.734 1.501 1.501 0 0 1 1.5 1.499A1.498 1.498 0 0 1 43 38.86h-3a1.501 1.501 0 0 0-1.5 1.499 1.498 1.498 0 0 0 1.5 1.498h1.5a1.498 1.498 0 0 0 1.5 1.499 1.5 1.5 0 0 0 1.5-1.499v-.27a4.5 4.5 0 0 0 2.9-4.986 4.494 4.494 0 0 0-4.4-3.735 1.5 1.5 0 0 1-1.5-1.498A1.497 1.497 0 0 1 43 29.87z",
    fill: "url(#o2a2hchgyc)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m7ybrt618b",
    x1: 34,
    y1: 10.391,
    x2: 34,
    y2: 49.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o2a2hchgyc",
    x1: 43,
    y1: 25.375,
    x2: 43,
    y2: 43.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "4rcmkjii5a",
    x: 0,
    y: 0.391,
    width: 68,
    height: 58.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.984314 0 0 0 0 0.866667 0 0 0 0 0.623529 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_1128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_1128",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.dd1a3d8588e19dfea465dc373e9d31ca.svg";
export { ForwardRef as ReactComponent };